import { CodeOutlined, QuestionCircleOutlined, MailOutlined, SafetyCertificateOutlined } from '@ant-design/icons';
import { Card, Space, Typography, Button, Row, Col } from 'antd';
import { NavLink } from 'react-router-dom';

const { Title, Text, Paragraph } = Typography;

export function AboutPage() {
  return (
    <Card
      bordered={false}
      style={{
        height: '100%',
        overflow: 'auto',
      }}
      bodyStyle={{
        padding: '16px',
      }}
    >
      <Space direction="vertical" size="small" style={{ width: '100%' }}>
        {/* Header Section */}
        <div style={{ textAlign: 'center', marginBottom: '8px' }}>
          <Title level={3} style={{ margin: 0, fontWeight: 600 }}>
            Ana Veri Yönetim Uygulaması
          </Title>
          <Text type="secondary" style={{ fontSize: '14px' }}>
            mdm.rsnet2.com.tr
          </Text>
        </div>

        {/* Version Info */}
        <Row gutter={[12, 12]}>
          <Col span={24}>
            <Card
              size="small"
              style={{
                background: '#fafafa',
                border: '1px solid #f0f0f0',
                borderRadius: '6px',
              }}
              bodyStyle={{ padding: '12px' }}
            >
              <Space align="start" size="small">
                <div
                  style={{
                    background: '#fff7e6',
                    borderRadius: '50%',
                    padding: '8px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    border: '1px solid #ffd591',
                  }}
                >
                  <CodeOutlined style={{ fontSize: '18px', color: '#faad14' }} />
                </div>
                <div>
                  <Text strong style={{ display: 'block', marginBottom: '4px', fontSize: '13px' }}>
                    Sürüm Bilgileri
                  </Text>
                  <Paragraph type="secondary" style={{ margin: 0, fontSize: '12px' }}>
                    Versiyon: {process.env.REACT_APP_MDM_VERSION}
                    {process.env.REACT_APP_MDM_IS_TEST_VERSION === 'true' ? ' - Test' : ''}
                    <br />
                    Yayın tarihi:{' '}
                    {process.env.REACT_APP_MDM_BUILD_DATE
                      ? `${process.env.REACT_APP_MDM_BUILD_DATE} - ${process.env.REACT_APP_MDM_COMMIT_HASH}`
                      : ''}
                    <br />
                  </Paragraph>
                </div>
              </Space>
            </Card>
          </Col>

          <Col span={24}>
            <Card
              size="small"
              style={{
                background: '#fafafa',
                border: '1px solid #f0f0f0',
                borderRadius: '6px',
              }}
              bodyStyle={{ padding: '12px' }}
            >
              <Space align="start" size="small">
                <div
                  style={{
                    background: '#e6f7ff',
                    borderRadius: '50%',
                    padding: '8px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    border: '1px solid #91d5ff',
                  }}
                >
                  <QuestionCircleOutlined style={{ fontSize: '18px', color: '#1890ff' }} />
                </div>
                <div>
                  <Text strong style={{ display: 'block', marginBottom: '4px', fontSize: '13px' }}>
                    Yardım ve Destek
                  </Text>
                  <Paragraph type="secondary" style={{ margin: 0, fontSize: '12px' }}>
                    Uygulama ile ilgili bilgi almak için yardım sayfasını ziyaret edebilirsiniz. Uygulamaya yönelik karşılaştığınız
                    sorunlar, talepler, öneriler ve şikayetler için "Portal &gt; Çağrı Sistemleri &gt; KVY (Kurumsal Veri Yönetimi) Çağrı
                    Sistemi" üzerinde talep açabilirsiniz.
                  </Paragraph>
                </div>
              </Space>
            </Card>
          </Col>

          <Col span={24}>
            <Card
              size="small"
              style={{
                background: '#fafafa',
                border: '1px solid #f0f0f0',
                borderRadius: '6px',
              }}
              bodyStyle={{ padding: '12px' }}
            >
              <Space align="start" size="small">
                <div
                  style={{
                    background: '#f6ffed',
                    borderRadius: '50%',
                    padding: '8px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    border: '1px solid #b7eb8f',
                  }}
                >
                  <MailOutlined style={{ fontSize: '18px', color: '#52c41a' }} />
                </div>
                <div>
                  <Text strong style={{ display: 'block', marginBottom: '4px', fontSize: '13px' }}>
                    İletişim
                  </Text>
                  <Paragraph type="secondary" style={{ margin: 0, fontSize: '12px' }}>
                    Diğer görüşleriniz için{' '}
                    <a href="mailto:anaveridestek@rsnet2.com.tr" style={{ color: '#1890ff' }}>
                      anaveridestek@rsnet2.com.tr
                    </a>{' '}
                    iletişim adresini kullanabilirsiniz.
                  </Paragraph>
                </div>
              </Space>
            </Card>
          </Col>
        </Row>

        {/* Links */}
        <div style={{ textAlign: 'center', marginTop: '8px' }}>
          <Space direction="vertical" size="small">
            <Button type="link" style={{ padding: '4px 0' }}>
              <NavLink to="/documentation/help" style={{ display: 'flex', alignItems: 'center', gap: '6px', color: 'inherit' }}>
                <QuestionCircleOutlined />
                Yardım sayfası
              </NavLink>
            </Button>
            <Button type="link" style={{ padding: '4px 0' }}>
              <NavLink to="/documentation/release-notes" style={{ display: 'flex', alignItems: 'center', gap: '6px', color: 'inherit' }}>
                <CodeOutlined />
                Sürüm notları
              </NavLink>
            </Button>
          </Space>
        </div>

        {/* Footer */}
        <div style={{ textAlign: 'center', marginTop: '8px' }}>
          <SafetyCertificateOutlined style={{ fontSize: '14px', color: '#8c8c8c' }} />
          <Text type="secondary" style={{ marginLeft: '6px', fontSize: '11px' }}>
            Kurumsal Veri Yönetimi
          </Text>
        </div>
      </Space>
    </Card>
  );
}
